import script from "./HeaderSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderSearch.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderSearch.vue?vue&type=style&index=0&id=1a28e56f&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a28e56f"]])

export default __exports__